module.exports = {"id":"173198","name":"Davide Astori","rating":"81","photo":"./data/images/photos/2/173198.png","club":{"name":"Fiorentina","logo":"./data/images/clubs/Fiorentina.png"},"positions":["DC"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/DavideAstori0.json
// module id = 1012
// module chunks = 0